import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.zella.app&_gl=1*1d44080*_up*MQ..*_ga*MTE1NzA2OTk4NS4xNzc2NjM5MDUy*_ga_6VGGZHMLM2*czE3NzY2MzkwNTEkbzEkZzAkdDE3NzY2MzkwNTEkajYwJGwwJGgw&hl=en_GB';
const APP_STORE_URL = 'https://apps.apple.com/gb/app/zella-fatigue-wellbeing/id6759653357';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">

        {/* Text */}
        <div className="hero-text">
          <h1 className="hero-title">
            Happier teams.{' '}
            <span className="highlight-green">Safer workplaces.</span>
            {' '}Better results.
          </h1>

          <p className="hero-subtitle">
            Zella's smart dashboard turns invisible fatigue into actionable data,
            helping you protect your people and your business.
          </p>

          <div className="hero-buttons">
            <Link to="/signup" className="btn-outline">Try it for free</Link>
            <button
              className="btn-outline"
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
            >
              How it works
            </button>
          </div>

          <div className="app-store-buttons">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-button apple"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="store-icon">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="store-text">
                <span className="store-label">Download on the</span>
                <span className="store-name">App Store</span>
              </div>
            </a>

            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-button google"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="store-icon">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="store-text">
                <span className="store-label">Get it on</span>
                <span className="store-name">Google Play</span>
              </div>
            </a>
          </div>

          <p className="app-note">Available for iOS and Android, free to download</p>
        </div>

        {/* Visual */}
        <div className="hero-visual">
          <div className="hero-image-blob">
            <img
              src="/AdobeStock_482295138.jpeg"
              alt="Employee feeling refreshed and energised at work"
              className="hero-team-photo"
            />
          </div>

          <div className="floating-card card-1">
            <div className="card-content">
              <span className="stat-value green">+20%</span>
              <span className="stat-label">Team Happiness</span>
            </div>
          </div>

          <div className="floating-card card-2">
            <div className="card-content">
              <span className="stat-value blue">-15%</span>
              <span className="stat-label">Tiredness</span>
            </div>
          </div>

          <div className="floating-card card-3">
            <div className="card-content">
              <span className="stat-value orange">High</span>
              <span className="stat-label">Team Engagement</span>
            </div>
          </div>
        </div>

      </div>
      <div className="hero-flower-decoration">
        <img src="/Zella flower shape@3x.png" alt="" aria-hidden="true" className="hero-flower-img" />
      </div>
    </section>
  );
}

export default Hero;
